import { RecordFolderAssignment } from '@provision/entity-types';
import { portalPaths } from '@provision/portal-routes';
import { type NavigationDataItem } from 'src/components/Navbar/use-navigation-items';
import { RecordFolder } from 'src/graphql';
import {
  CustomView,
  EntityRulesData,
  RULES_MAP_PER_VIEW_ENTITY,
} from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';

const ICON_TO_ENTITY = {
  CustomView: 'star',
  Conversation: 'message-circle',
};

export const mapAssignmentToNavItem = (data: {
  assignment: RecordFolderAssignment;
  folder: RecordFolder;
  customViews: CustomView[];
  selectedPartnerId: string | number | null;
  deleteAssignment?: (assignment: RecordFolderAssignment) => Promise<void>;
}): NavigationDataItem => {
  const { assignment, customViews, folder, selectedPartnerId, deleteAssignment } = data;

  let path = '';
  let icon = '';
  let title = assignment.title;
  let restrictions: EntityRulesData | undefined;

  if (assignment.entity === 'CustomView') {
    const view = customViews.find((v) => v.customViewId === assignment.entityId);
    if (view) {
      path = portalPaths.entity.selected(view.entityName, view.customViewId);
      icon = view.icon;
      title = view.name;
      restrictions = RULES_MAP_PER_VIEW_ENTITY[view.entityName] ?? {};
    }
  } else if (assignment.entity === 'Conversation') {
    path = portalPaths.conversation.full(assignment.entityId);
  }

  if (!restrictions) {
    restrictions =
      RULES_MAP_PER_VIEW_ENTITY[assignment.entity.toLowerCase() as EntityNames] ?? {};
  }

  return {
    ...restrictions,
    id: assignment.recordFolderAssignmentId,
    rawAssignmentItem: assignment,
    title,
    iconData: {
      name:
        icon ||
        ICON_TO_ENTITY[assignment.entity as keyof typeof ICON_TO_ENTITY] ||
        folder.icon ||
        'folder',
      library: 'lucide',
    },
    path,
    customViewId: assignment.entityId,
    menuItems:
      deleteAssignment && selectedPartnerId === assignment.partnerId
        ? [
            {
              icon: 'trash-2',
              iconLibrary: 'lucide',
              label: 'Remove from folder',
              onClick: () => {
                void deleteAssignment(assignment);
              },
            },
          ]
        : undefined,
  };
};
